import React from 'react'
import DataTable from '../../components/DataTable/DataTable'


function AllSessions() {
    return (
        <>
            <div className='mt-[80px]'>
                <DataTable />
            </div>
        </>
    )
}

export default AllSessions